"use strict";

/**
* Lazy loads the video content
*/
const lazyLoadVideos = () => {
    const lazyVideosNodes = document.querySelectorAll("video.lazy-video");
    const lazyVideos = Array.from(lazyVideosNodes);

    if (lazyVideosNodes.length > 0) {
        const lazyVideoObserver = new IntersectionObserver((entries, _observer) => {
            entries.forEach(video => {
                if (video.isIntersecting) {
                    const windowWidth = window.innerWidth;

                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            if (windowWidth <= 767) {
                                videoSource.src = videoSource.dataset.srcMobile ? videoSource.dataset.srcMobile : videoSource.dataset.src;
                            } else {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy-video");
                    video.target.classList.add("lazy-video--loaded");
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(lazyVideo => {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
};

module.exports = {
    lazyLoadVideos
};
